// location data state (relates to current users page (area/space) not current users joined space)
// https://mccglc.atlassian.net/l/c/ihQBVJE7 for DOCS

const state = {
  // location -------------------------------------------------------------
  currentLocation: {}, //users current route/page (area/room)
};

const getters = {
  getCurrentLocationData: (state) => {
    return state.currentLocation;
  },
  // LOCATION -------------------------------------------------------------
  // get id of current location (space/area)
  getCurrentLocationId: (state,getters) => {
    return getters.getCurrentLocationData?.id || ''
  },
  // get if location type is area or space
  getCurrentLocationType: (state,getters) => {
    return getters.getCurrentLocationData?.locationType || ''
  },
  // get location name/title
  getCurrentLocationName: (state,getters) => {
    return getters.getCurrentLocationData?.name || ''
  },
  getAreaIdFromLocation: (state,getters) => {
    switch(getters.getCurrentLocationType) {
      case 'area':
        return getters.getCurrentLocationId
      case 'space':
        return getters.getCurrentLocationData?.parentId || ''
      default:
        return ''
    }
  },
};

const mutations = {
  // location -------------------------------------------------
  setCurrentLocation(state, data) {
    state.currentLocation = data;
  },
};

const actions = {
  // location -------------------------------------------------
  //updates when current location changes (users join, etc) - comes from Dispatch event from SignalR connection (indexAPI)
  async updateLocation({getters, commit, dispatch}, [data, fromMessageQueue = false]) {
    let locationData = data.location ? data.location : data
    let locationType = data.locationType

    if (data.location) dispatch('current_user/updateGuestState', data)
    if (data.permissions) dispatch('permissions/setPermissions', data.permissions)

    if (data.whereabouts) {
      await dispatch('updateWhereabouts', data.whereabouts)
    }

    //block area updates if on room page incase navigator location is thrown off to prevent a blank screen
    if(locationType === 'area' && getters['routing/routeName'] === 'room' && fromMessageQueue) return console.warn('UPDATE BLOCKED!!!', data)

    commit('setCurrentLocation', locationData)
    commit('setNewChatWaiting', false);

    // note: only updates the .location property of each of these
    if(locationType === 'area') await dispatch('updateCurrentArea', {data})
    else if(locationType === 'space') await dispatch('updateCurrentSpacePage', data)

    dispatch('updateCurrentUsersRoom', data);
  },
  async clearLocationData({commit}) {
    commit('setCurrentLocation', {})
  },

  // SHARE LOCATION
  async shareLocation({dispatch}) {
    let url = location.href
    await navigator.clipboard.writeText(url);
    dispatch('popups/show/success', {
      message: 'Link successfully copied to clipboard. <br><br> <small>Please note this link is only available for members of this Space.</small>'
    })
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
